import {
  PRODUCT_INVENTORY_REQUEST,
  PRODUCT_INVENTORY_SUCCESS,
  PRODUCT_INVENTORY_FAILURE,
  PRODUCT_DETAILS_REQUEST,
  PRODUCT_DETAILS_SUCCESS,
  PRODUCT_DETAILS_FAILURE,
  PRODUCT_FILTERS_SUCCESS,
  PRODUCT_FILTERS_FAILURE,
  PRODUCT_SET_FILTERS_SUCCESS,
  PRODUCT_SET_FILTERS_CLEAR,
  PRODUCT_SET_SEARCH_QUERY,
  PRODUCT_GROUP_BY,
  PRODUCT_SET_INACTIVE_REQUEST,
  PRODUCT_SET_INACTIVE_SUCCESS,
  PRODUCT_SET_INACTIVE_FAILURE,
  PRODUCT_SET_GLOBAL_INACTIVE_FILTER_SUCCESS,
  PRODUCT_INVENTORY_STATS_SUCCESS,
  PRODUCT_INVENTORY_STATS_FAILURE,
  PRODUCT_INVENTORY_EXPORT_SUCCESS,
  PRODUCT_INVENTORY_EXPORT_FAILURE,
  RESET_EXPORT_FILE_URL,
  UPDATE_SPECIALTY_USE_VALUE_SUCCESS,
  UPDATE_SPECIALTY_USE_VALUE_ERROR
} from './actions';

import createReducer from 'state/createReducer';

import _ from 'lodash';

const initialState = {
  request: false,
  errorMessage: null,
  data: [],
  detailsData: {},
  detailsRequest: false,
  filters: [],
  activeFilters: {},
  searchFilterQuery: '',
  globalInactiveFilter: true,
  groupById: '',
  IDsInProcess: [],
  exportFileUrl: null
}

const handlers = {

  [PRODUCT_SET_GLOBAL_INACTIVE_FILTER_SUCCESS](state, payload) {
    return {
      ...state,
      globalInactiveFilter: payload
    }
  },

  [PRODUCT_SET_INACTIVE_REQUEST](state, payload) {

    const newDetails = {...state.detailsData}

    if (_.has(payload, 'details') && payload.details === true) {
      newDetails.inactiveRequest = true;
    }

    const newData = [...state.data];

    if (payload.groupIdx !== -1 || payload.idx !== -1) {
      if ( state.groupById.length <= 0 ) {
        newData[payload.idx].inactiveRequest = true;
      } else {
        newData[payload.groupIdx].productGroups[payload.idx].inactiveRequest = true;
      }
    }

    return {
      ...state,
      data: newData,
      detailsData: newDetails
    }
  },

  [PRODUCT_SET_INACTIVE_SUCCESS](state, payload) {

    const newDetails = {...state.detailsData }
    if ( _.has(payload, 'details') && payload.details === true ) {
      newDetails.inactiveRequest = false;
      newDetails.productGroup.inactive = payload.inactive;
    }

    const newData = [...state.data];

    if ( payload.groupIdx !== -1 || payload.idx !== -1 ) {
      if (state.groupById.length <= 0) {
        newData[payload.idx].inactiveRequest = false;
        newData[payload.idx].isInactive = payload.inactive;
      } else {
        newData[payload.groupIdx].productGroups[payload.idx].inactiveRequest = false;
        newData[payload.groupIdx].productGroups[payload.idx].isInactive = payload.inactive;
      }
    }

    return {
      ...state,
      data: newData,
      detailsData: newDetails
    }
  },

  [PRODUCT_SET_INACTIVE_FAILURE](state, payload) {
    
    if ( payload.idx === -1 ) {
      return {
        ...state
      }
    }

    const newData = [...state.data];

    if ( state.groupById.length <= 0 ) {
      newData[payload.idx].inactiveRequest = false;
    } else {
      newData[payload.groupIdx].productGroups[payload.idx].inactiveRequest = false;
    }

    return {
      ...state,
      data: newData,
    }
  },

  [PRODUCT_GROUP_BY](state, payload) {
    return {
      ...state,
      groupById: payload
    }
  },

  [PRODUCT_SET_FILTERS_SUCCESS](state, payload) {
    return {
      ...state,
      activeFilters: payload
    }
  },

  [PRODUCT_SET_FILTERS_CLEAR](state) {

    const activeFilters = {...state.activeFilters}

    Object.keys(activeFilters).forEach((v) => {
      activeFilters[v] = [];
    });


    return {
      ...state,
      activeFilters: activeFilters
    }
  },


  [PRODUCT_FILTERS_SUCCESS](state, payload) {

    let activeFilters = {...state.activeFilters}

    payload.meta.availableFilters.forEach((v) => {
      if (Array.isArray(activeFilters[v.queryStringCode]) === false) {
        activeFilters[v.queryStringCode] = [];  
      }
    });

    return {
      ...state,
      activeFilters: activeFilters,
      filters: payload
    }
  },

  [PRODUCT_FILTERS_FAILURE](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  },

  [PRODUCT_DETAILS_REQUEST](state, payload) {
    return {
      ...state,
      detailsRequest: payload,
      errorMessage: null
    }
  },

  [PRODUCT_DETAILS_FAILURE](state, payload) {
    return {
      ...state,
      detailsRequest: false,
      errorMessage: payload.errorMessage
    }
  },

  [PRODUCT_DETAILS_SUCCESS](state, payload) {

    let detailsData = {
      productGroup: _.get(payload, 'productGroup', null),
      products: _.get(payload, 'products', null),
      inventories: _.get(payload, 'inventories', null),
      inactiveRequest: false
    }

    return {
      ...state,
      detailsRequest: false,
      errorMessage: null,
      detailsData: detailsData,
    }
  },

  [PRODUCT_INVENTORY_REQUEST](state) {
    return {
      ...state,
      request: true,
      errorMessage: null
    }
  },

  [PRODUCT_INVENTORY_SUCCESS](state, payload) {

    return {
      ...state,
      request: false,
      errorMessage: null,
      data: payload.data
    }
  },

  [PRODUCT_INVENTORY_FAILURE](state, payload) {
    return {
      ...state,
      request: false,
      errorMessage: payload.errorMessage
    }
  },

  [PRODUCT_SET_SEARCH_QUERY](state, payload) {
    return {
      ...state,
      searchFilterQuery: payload
    }
  },
  
  [PRODUCT_INVENTORY_STATS_SUCCESS](state, payload) {
   
    if (payload.data !== null) {
      return {
        ...state,
        IDsInProcess: payload.data
      }
    }
    return {
      ...state
    }
  },

  [PRODUCT_INVENTORY_EXPORT_SUCCESS](state, payload) {

    const url = window.URL.createObjectURL(new Blob([payload.data] ,{type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}));

    return {
      ...state,
      exportFileUrl: url
    }
  },

  [PRODUCT_INVENTORY_EXPORT_FAILURE](state) {
    return {
      ...state
    }
  },
  
  [RESET_EXPORT_FILE_URL](state) {
    return {
      ...state,
      exportFileUrl: null
    }
  },

  [UPDATE_SPECIALTY_USE_VALUE_SUCCESS](state) {
    return {
      ...state,
    }
  },

  [UPDATE_SPECIALTY_USE_VALUE_ERROR](state, payload) {
    return {
      ...state,
      errorMessage: payload.errorMessage
    }
  },

}

export default (state = initialState, action) => createReducer(state, action, handlers); 
